import { createReducer } from '@reduxjs/toolkit';
import { updateNatalChartBlockValues } from './actions';
import { contentInitialState } from './state';

export const contentReducer = createReducer(contentInitialState, (builder) => {
  builder.addCase(updateNatalChartBlockValues, (state, { payload }) => ({
    ...state,
    natalChartBlockValues: payload,
  }));
});
